import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// States matching your Flutter enum
export const QoboState = {
  IDLE: 'idle',
  WORKING: 'working',
  TALKING: 'talking'
};

export const QoboWidget = ({ 
  state = QoboState.IDLE, 
  size = 120, 
  primaryColor = "#8E24AA" 
}) => {
  
  // Base coordinate system (matching Flutter logic)
  const baseSize = 100; 
  const center = baseSize / 2;

  // Animation Variants
  const variants = {
    // Body Bounce & Squash/Stretch
    body: {
      idle: {
        y: [0, -6, 0],
        transition: { duration: 2, repeat: Infinity, ease: "easeInOut" }
      },
      working: {
        y: [0, -3, 0],
        transition: { duration: 0.3, repeat: Infinity, ease: "easeInOut" }
      },
      talking: {
        scaleY: [1, 1.1, 0.95, 1],
        transition: { duration: 0.4, repeat: Infinity, ease: "linear" }
      }
    },
    // Eye Blinking
    eyes: {
      idle: {
        scaleY: [1, 1, 1, 0.1, 1],
        transition: { duration: 3, repeat: Infinity, times: [0, 0.8, 0.9, 0.95, 1] }
      },
      working: { scaleY: 1 },
      talking: { scaleY: 1 }
    },
    // Working State Scan Beam
    beam: {
      initial: { opacity: 0, scaleY: 0 },
      animate: { 
        opacity: [0, 0.6, 0], 
        scaleY: [0, 1.5, 2],
        transition: { duration: 1.5, repeat: Infinity, ease: "linear" } 
      }
    }
  };

  return (
    <div style={{ width: size, height: size, position: 'relative' }}>
      <svg 
        viewBox={`0 0 ${baseSize} ${baseSize}`} 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: '100%', height: '100%', overflow: 'visible' }}
      >
        <defs>
          <linearGradient id="beamGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="white" stopOpacity="0.6" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>

        {/* 1. Working State Scan Beam (Sits behind body) */}
        <AnimatePresence>
          {state === QoboState.WORKING && (
            <motion.path
              variants={variants.beam}
              initial="initial"
              animate="animate"
              exit={{ opacity: 0 }}
              d="M 35 45 L 10 110 L 90 110 L 65 45 Z"
              fill="url(#beamGradient)"
              style={{ transformOrigin: 'top' }}
            />
          )}
        </AnimatePresence>

        {/* --- MAIN CHARACTER GROUP --- */}
        <motion.g
          variants={variants.body}
          animate={state}
          style={{ transformOrigin: '50% 70%' }}
        >
          {/* 1. Antenna */}
          <line x1={center} y1="20" x2={center} y2="10" stroke={primaryColor} strokeWidth="4" strokeLinecap="round" />
          <circle cx={center} cy="8" r="6" fill={primaryColor} />

          {/* 2. Body (Rounded Rect) */}
          <rect 
            x={center - 35} 
            y={center - 25} 
            width="70" 
            height="60" 
            rx="15" 
            fill={primaryColor} 
          />

          {/* 3. Eyes (Blinking Group) */}
          <motion.g variants={variants.eyes} animate={state} style={{ transformOrigin: 'center 45%' }}>
            {/* Left Eye */}
            <circle cx={center - 18} cy={center - 5} r="10" fill="white" />
            <circle cx={center - 18} cy={center - 5} r="4" fill="#212121" />
            
            {/* Right Eye */}
            <circle cx={center + 18} cy={center - 5} r="10" fill="white" />
            <circle cx={center + 18} cy={center - 5} r="4" fill="#212121" />
          </motion.g>
        </motion.g>
      </svg>
    </div>
  );
};